import React from 'react'
import i18next from 'i18next'
import { formatDateDDMonthYYYY } from '../../../../utils/date'
import { Image, ImageBase } from '../../../../utils/image'
import { specialistsSrc } from '../../../../utils/imageSizes'
import { Link } from '../../../../utils/link'
import { GenericPageHeader } from '../../../sharedLayout/pageheader'
import { DecorativeIcon } from '../../../../utils/spaarneIcons'
import { Link as LinkType } from '../../cmsPageState'

type NewsPageHeaderProps = {
  title: string
  intro: string
  link?: LinkType
  image?: ImageBase
  date?: Date
  author?: {
    url?: string
    name: string
    job: string
    image?: ImageBase
  }
  breadcrumbs: LinkType[]
  dossier?: LinkType
}

export const NewsPageHeader = (props: NewsPageHeaderProps) => {
  const AuthorContent = props.author && (
    <>
      <address className="author__text">
        <p className="author__name">
          <span className="sr-text">{i18next.t('a11y:articleIsWrittenBy')} </span>
          {props.author.name}
        </p>
        <p className="author__label label--m">{props.author.job}</p>
      </address>
      {props.author.image && (
        <div className="author__visual fit-object">
          <Image
            urls={props.author.image.urls}
            src={specialistsSrc}
            classNames={{ image: 'author__image' }}
            alt={props.author.image.alt}
            lazyload={true}
          />
        </div>
      )}
    </>
  )
  return (
    <GenericPageHeader
      kind="newsDetail"
      breadcrumbs={props.breadcrumbs}
      title={props.title || ''}
      intro={props.intro}
      link={props.link}
      image={props.image}
      extraJSXBelowTitle={
        <>
          {/* Publish date */}
          <p className="pageheader__label">
            <span className="sr-text">{i18next.t('common:publishDate')}</span>
            {props.date && (
              <time
                dateTime={props.date.toISOString()}
                title={`${i18next.t('common:publishDate')} ${formatDateDDMonthYYYY(props.date)}`}
              >
                {formatDateDDMonthYYYY(props.date)}
              </time>
            )}
          </p>
          {/* Author */}
          {props.author && (
            <div
              className="pageheader__author author"
              title={`${i18next.t('a11y:articleIsWrittenBy')}${props.author.name}`}
            >
              {props.author.url ? (
                <Link url={props.author.url} rel="author" className="author__link author__inner">
                  {AuthorContent}
                </Link>
              ) : (
                <div className="author__inner">{AuthorContent}</div>
              )}
            </div>
          )}
        </>
      }
      extraJSXBelowText={
        <>
          {props.dossier?.title && props.dossier?.url && (
            <Link url={props.dossier.url} className={"dossier__label label--m"}>
              <DecorativeIcon iconId={"icon--folders"} width="24px" height="24px" />
              <span>{props.dossier.title ?? i18next.t("dossier:DossierTag")}</span>
            </Link>
          )}
        </>
      }
    />
  )
}
